import { animate } from "//decked.com/cdn/shop/t/432/assets/static.vendor.min.js?v=161072099565793977701771259838";

var VehiclePicker = class extends HTMLElement {

  constructor() {
    super();
    this.features = {
      selectDefaults: true,
      button: false,
      noVehicle: false,
      noVehicleLink: true,
    };
    this.noVehicleLink = '/pages/fitment';
  }

  init() {

    let initialVehicle = null;

    if ( typeof VehicleData !== "undefined" && VehicleData ) {
      VehicleData.init();
      initialVehicle = VehicleData.getSelectedVehicle();
    }else{
      window.setTimeout(() => {
        this.init();
      }, 1000);
      return;
    }

    this.innerHTML = '';

    if (initialVehicle) {
      this.make = initialVehicle.make;
      this.model = initialVehicle.model;
      this.year = initialVehicle.year;
    } else {
      this.make = null;
      this.model = null;
      this.year = null;

      // Hide ATC PDP if no Vehicle Selected (it's unhidden on vehicleSelected event listener on VpvBuyButtons)
      const buttons = document.querySelector('.product-info vpv-buy-buttons')
      if(buttons){
        buttons.setAttribute('hidden', '');
      }
    }

    //this.vehicleJsonData = null;
    this.visible = true;

    this.makes = [];
    this.foundProducts = [];

    this.systemProductHandle = this.getAttribute("system-product-handle");
    this.systemProductTitle = this.getAttribute("system-product-title");
    this.resetUrl = this.getAttribute("reset-url");

    this.mode = this.getAttribute("mode");

    const $top = document.createElement("div");
    $top.classList.add('vehiclePicker__selects__top');

    const $title = document.createElement("div");
    $title.classList.add('vehiclePicker__selects__title');
    $title.innerText = "Find Your Vehicle";

    const $clearAll = document.createElement("a");
    $clearAll.innerText = "Clear all";
    $clearAll.classList.add("clear-all", "link", "link-sm");
    if(this.resetUrl){
      $clearAll.setAttribute("href", this.resetUrl);
    }
    $clearAll.addEventListener("click", () => {
      this.clearAll();
    });

    $top.appendChild($title);
    $top.appendChild($clearAll);

    this.$container = document.createElement("div");
    this.$container.classList.add("vehiclePicker__container");
    this.$container.classList.add(`mode--${this.mode}`);

    this.$container.addEventListener("click", () => {
      if (this.mode == "modal") this.close();
    });

    this.$selects = document.createElement("div");
    this.$selects.classList.add("vehiclePicker__selects");

    if (initialVehicle) {
      //prevent the selects from showing on page load
      this.$selects.classList.add("hide");
      this.$selects.style.height = '0';
      this.$selects.style.overflow = 'hidden';
      this.$selects.style.display = 'none';
    }else{
      this.makeSelect && this.resetMake();
      this.modelSelect && this.resetModel();
      this.yearSelect && this.resetYear();
    }

    this.$selects.appendChild($top);

    const previewFile = window.localStorage.getItem('vehicleDataPreviewFile');
    if(previewFile){
      const $preview = document.createElement("div");
      $preview.classList.add('vehiclePicker__selects__preview', 'banner', 'banner--warning', 'banner--with-button');
      $preview.innerHTML = `<p>Previewing <span>${previewFile}</span> </p><a href="?vp-preview=null" class="button button--sm" id="vehicleDataPreviewClear">Clear</a>`;
      this.$selects.appendChild($preview);
    }

    // $selects.addEventListener("click", ev => {
    //   ev.stopPropagation();
    //   this.collapseAllSelects();
    // });

    // Create select elements
    this.makeSelect = this.makeSelect || this.createSelect("make");
    this.selectOptions([], this.makeSelect.querySelector("select"), "Select Make...");
    this.modelSelect = this.modelSelect || this.createSelect("model");
    this.selectOptions([], this.modelSelect.querySelector("select"), "Select Model...");
    this.yearSelect = this.yearSelect || this.createSelect("year");
    this.selectOptions([], this.yearSelect.querySelector("select"), "Select Year...");

    this.$error = document.createElement("div");
    this.$error.classList.add("JSONDataError");

    this.$shopNowButton = document.createElement("button");
    this.$shopNowButton.classList.add("button", "button--xl", "w-full");
    this.disableButton();

    if (this.mode == "modal") {
      const $close = document.createElement("a");
      $close.classList.add("close");
      $close.setAttribute("href", "#");
      $close.innerHTML = `<svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L21 21" stroke="currentColor" stroke-width="2"/><path d="M21 1L1 21" stroke="currentColor" stroke-width="2"/></svg> `;

      $close.addEventListener("click", ev => {
        ev.stopPropagation();
        ev.preventDefault();
        this.close();
        return false;
      });

      this.$selects.appendChild($close);
    }

    this.$shopNowButton.addEventListener("click", (e) => {
      console.log('shop now button clicked');
      if (this.foundProducts.length > 0) {
        this.close();

        VehicleData.selectVehicle({
          make: this.make,
          model: this.model,
          year: this.year
        });

        const vehicleSubmittedEvent = new CustomEvent("vehicleSubmitted", {
          detail: {
            make: this.make,
            model: this.model,
            year: this.year
          },
          bubbles: true,
          cancelable: true,
          composed: false,
        });

        this.dispatchEvent(vehicleSubmittedEvent);

      } else {
        e.preventDefault();
        e.stopPropagation();
        this.openMakeSelect();
      }
    });

    this.$selects.appendChild(this.makeSelect);
    this.$selects.appendChild(this.modelSelect);
    this.$selects.appendChild(this.yearSelect);
    this.$selects.appendChild(this.$shopNowButton);

    this.$selects.appendChild(this.$error);

    this.$container.appendChild(this.$selects);

    this.appendChild(this.$container);


    window.addEventListener("click", () => {
      this.collapseAllSelects();
    });

  }

  addNoVehicleLink() {
    // remove existing no vehicle link
    this.$changeVehicle?.remove();
    // don't see your vehicle link
    if(this.features.noVehicleLink){
      this.$changeVehicle = document.createElement("a");
      this.$changeVehicle.classList.add("no-vehicle", "link", "link-sm", "mt-2", "inline-block");
      this.$changeVehicle.setAttribute("href", this.noVehicleLink);
      this.$changeVehicle.innerText = "Don't see your vehicle?";
      this.$changeVehicle.addEventListener("click", () => {
        this.clearAll();
      });
      this.$selects && this.$selects.appendChild(this.$changeVehicle);
    }
  }

  enableButton() {
    !this.features.button && this.$shopNowButton.removeAttribute("disabled");
    this.$shopNowButton.innerHTML = "Shop Now";
  }

  disableButton() {
    if(this.features.button){
      this.$shopNowButton.removeAttribute("disabled");
    }else{
      this.$shopNowButton.setAttribute("disabled", "disabled");
    }
    this.$shopNowButton.innerHTML = "Select Vehicle";
  }

  openMakeSelect() { 
    this.toggleSelectOptions(this.makeSelect);
  }

  collapseAllSelects(){
    this.makeSelect.classList.remove("on");
    this.modelSelect.classList.remove("on");
    this.yearSelect.classList.remove("on");
  }

  createSelect(selectID) {
    const $select = document.createElement("div");
    const $ul = document.createElement("ul");
    const $button = document.createElement("button");

    $select.classList.add("select");

    $select.setAttribute("id", `${selectID}-select`);

    $button.innerHTML = `<span>${selectID}</span><svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 1.76514L8 7.23506L2 1.76514" stroke="currentColor" stroke-width="3"/>
    </svg>
    `;

    $button.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggleSelectOptions($select);
    });

    $select.appendChild($button);
    $select.appendChild($ul);

    return $select;
  }

  changeVehicle() {
    this.open();
  }

  resetMake() {
    this.make = "";
    this.makeSelect.querySelector("button span").innerText = "Make";
    this.makeSelect.classList.remove("on");
    // this.selectOptions([], this.makeSelect.querySelector("select"), "Select Make...");
    // this.makeSelect.querySelector('ul').innerHTML = '';
  }

  resetModel() {
    this.model = "";
    this.modelSelect.querySelector("button span").innerText = "Model";
    this.modelSelect.querySelector("ul").innerHTML = "";
    this.modelSelect.classList.remove("on");
    this.selectOptions([], this.modelSelect.querySelector("select"), "Select Model...");
  }

  resetYear() {
    this.year = "";
    this.yearSelect.querySelector("button span").innerText = "Year";
    this.yearSelect.querySelector("ul").innerHTML = "";
    this.yearSelect.classList.remove("on");
    this.selectOptions([], this.yearSelect.querySelector("select"), "Select Year...");
  }

  toggleSelectOptions($select) {

    $select.display = "none";
    if ($select.querySelectorAll("li").length > 0) $select.classList.toggle("on");

    if (!$select.isEqualNode(this.makeSelect)) this.makeSelect.classList.remove("on");
    if (!$select.isEqualNode(this.modelSelect)) this.modelSelect.classList.remove("on");
    if (!$select.isEqualNode(this.yearSelect)) this.yearSelect.classList.remove("on");

  }

  clearAll() {
    this.resetMake();
    this.resetModel();
    this.resetYear();

    this.disableButton();

    this.close();
    VehicleData.reset();
    window.dispatchEvent(
      new CustomEvent("vehiclePickerReset", {
        detail: {},
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }

  open() {
    window.setTimeout(() => {
      const select = this.querySelector("div.vehiclePicker__selects");

      if (this.mode == "modal") document.querySelector('html').classList.add('lock');
      this.$container.classList.add(`opened`);
      select.style.display = "block";
      select.style.overflow = 'hidden';
      const currentHeight = this.offsetHeight;

      animate(select, { 
        height: ['0', `${currentHeight}px`]
      }, 300 )
      .finished
      .then(() => {
        select.style.overflow = 'visible';
        select.style.height = 'auto';
      });

      window.dispatchEvent(
        new CustomEvent("vehiclePickerOpened", {
          detail: {},
          bubbles: true,
          cancelable: true,
          composed: false,
        })
      );
    }, 0);
  }

  close() {
    this.hideSelects();
    document.querySelector('html').classList.remove('lock');
    this.$container.classList.remove(`opened`);

    window.dispatchEvent(
      new CustomEvent("vehiclePickerClosed", {
        detail: {},
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }

  hideSelects() {
    const select = this.querySelector("div.vehiclePicker__selects:not(.hide)");
    if (!select) return;
    select.classList.add("hide");
    select.style.overflow = 'hidden';

    const oldHeight = select.offsetHeight; 
    
    animate(select, {
      height: [oldHeight + "px", 0 + "px"],
    }, 300)
    .finished
    .then(() => {
      select.style.display = 'none';
      select.style.overflow = 'visible';
      select.style.height = 'auto';
    });
  }

  select(option, value) {
    if (option == "make") {
      this.resetModel();
      this.resetYear();

      const makeId = value;
      this.make = makeId;

      this.foundProducts = [];

      const makeModels = this.searchModelsByMake(makeId);
      this.modelOptions(makeModels);
      this.yearOptions([]);

      // modelSelect.dispatchEvent(new Event('change'));
      this.disableButton();

      this.makeSelect.classList.remove("on");
      this.makeSelect.querySelector("button span").innerText = `${value}`;
      if (makeModels.length>0) { 
        this.modelSelect.classList.add("on");
      }
    } else if (option == "model") {
      this.resetYear();

      this.foundProducts = [];

      const modelId = value;
      this.model = modelId;

      // Populate the year dropdown with the options for the selected model
      const modelYears = this.searchYearsByMakeModel(this.make, modelId).sort((a, b) => b - a);
      this.yearOptions(modelYears);

      this.disableButton();

      this.modelSelect.classList.remove("on");
      this.modelSelect.querySelector("button span").innerText = `${value}`;
      if (modelYears.length>0) { 
          this.yearSelect.classList.add("on");
      }
    } else if (option == "year") {
      this.year = value;

      const products = this.searchProductsByMakeModelYear(this.make, this.model, this.year);


      this.yearSelect.classList.remove("on");
      this.yearSelect.querySelector("button span").innerText = `${value}`;

      if (products.length > 0) {
        this.foundProducts = products;
        this.enableButton();
      } else {
        this.disableButton();
      }
    }
  }

  // Define the component's markup and styling
  connectedCallback() {

    this.init();
    window.addEventListener("vehicleCleared", e => {
      this.init();
    });

    if(window.__VPV.vehicleJsonReady){
      this.setupSelectOptions(window.__VPV.vehicleData.byTemplate);
      this.addNoVehicleLink();
    }

    // Load the data from the JSON file
    window.addEventListener("vehicleJsonReady", e => {
      this.setupSelectOptions(e.detail);
      this.addNoVehicleLink();
    });
  }

  selectOptions(data, placeholder = "Please Select...") {
    const firstOption = document.createElement("option");
    firstOption.disabled = true;
    firstOption.value = "";
    firstOption.textContent = placeholder;
    firstOption.selected = true;

    data.forEach(item => {
      const option = document.createElement("option");
      option.value = item;
      option.textContent = item;
    });
  }

  makeOptions(data) {
    const makeSelect = this.makeSelect;

    const $ul = makeSelect.querySelector("ul");
    $ul.innerHTML = "";

    this.makes = data.map(({make}) => make).filter((value, index, self) => self.indexOf(value) === index);

    // in reverse order so anything not in the list drops to the end
    const order = ["Mercedes Benz (all Sprinters)", "Sprinter Van", "Jeep Trucks", "Jeep", "Nissan", "GMC", "Toyota", "Ram",  "Chevy", "Ford"];

    const compare = (a, b) => {
      const indexA = order.indexOf(a);
      const indexB = order.indexOf(b);
      if (indexA < indexB) {
        return 1;
      } else if (indexA > indexB) {
        return -1;
      } else {
        return 0;
      }
    };

    const sortedData = this.makes.sort(compare);

    this.selectOptions(sortedData, "Select Make...");

    sortedData.forEach(make => {
      //if (this.makes.includes(make.make)) return;
      const option = document.createElement("li");
      option.setAttribute("data-value", make.make);

      option.addEventListener("click", e => {
        this.select("make", make);
        e.stopPropagation();
      });

      option.value = make;
      option.textContent = make;

      $ul.appendChild(option);
      //this.makes.push(make.make);
    });

  }

  modelOptions(data) {
    const modelSelect = this.modelSelect;

    const $ul = modelSelect.querySelector("ul");
    $ul.innerHTML = "";

    const containsVanOrService = str => str.includes("Van") || str.includes("Service");

    data.sort((a, b) => {
      if (containsVanOrService(a) && !containsVanOrService(b)) {
        return 1;
      } else if (!containsVanOrService(a) && containsVanOrService(b)) {
        return -1;
      } else {
        return a.localeCompare(b);
      }
    });

    this.selectOptions(data, modelSelect.querySelector("select"), "Select Model...");

    if(this.features.selectDefaults && data.length === 0){
      const option = document.createElement("li");
      option.setAttribute("data-value", null);
      option.textContent = "Select Vehicle Make First...";
      option.addEventListener("click", ev => {
        //trigger click on makeSelect
        ev.stopPropagation();
        this.toggleSelectOptions(this.makeSelect);
      });
      $ul.appendChild(option);
    }else{
      data.forEach(model => {
        const option = document.createElement("li");
        option.setAttribute("data-value", model);
        option.textContent = model;

        option.addEventListener("click", ev => {
          this.select("model", model);
          ev.stopPropagation();
        });

        $ul.appendChild(option);
      });

      if (this.features.noVehicle) {
        const option = document.createElement("li");
        option.setAttribute("data-value", "no-vehicle");
        option.textContent = "Don't see your vehicle?";
        option.classList.add("external-link");
        option.addEventListener("click", ev => {
          location.href = this.noVehicleLink;
          ev.stopPropagation();
        });
        $ul.appendChild(option);
      }

    }
  }

  yearOptions(data) {
    const yearSelect = this.yearSelect;

    const $ul = yearSelect.querySelector("ul");
    $ul.innerHTML = "";

    this.selectOptions(data, yearSelect.querySelector("select"), "Select Year...");

    if(this.features.selectDefaults && data.length === 0){
      const option = document.createElement("li");
      option.setAttribute("data-value", null);
      option.textContent = "Select Vehicle Make and Model First...";
      option.addEventListener("click", ev => {
        //trigger click on makeSelect
        ev.stopPropagation();
        this.toggleSelectOptions(this.makeSelect);
      });
      $ul.appendChild(option);
    }else{
      data.forEach(year => {
        const option = document.createElement("li");
        // if (currentYear == year) option.setAttribute('selected', 'selected')
        option.value = year;
        option.textContent = year;

        option.addEventListener("click", ev => {
          this.select("year", year);
          ev.stopPropagation();
        });

        $ul.appendChild(option);
      });

      if (this.features.noVehicle) {
        const option = document.createElement("li");
        option.setAttribute("data-value", "no-vehicle");
        option.classList.add("external-link");
        option.textContent = "Don't see your vehicle?";
        option.addEventListener("click", ev => {
          location.href = this.noVehicleLink;
          ev.stopPropagation();
        });
        $ul.appendChild(option);
      }

    }
  }

  setupSelectOptions(allVehicleObjs) {

    if (VehicleData.getSelectedVehicle() && this.mode !== 'section') {
      this.hideSelects();
    }

    this.vehicleJsonData = allVehicleObjs;
    this.makeOptions(this.vehicleJsonData);
    this.modelOptions([]);
    this.yearOptions([]);
  }

  disconnectedCallback() {
    // this._abortController.abort();
  }

  searchModelsByMake(make) {
    //const filteredData = this.vehicleJsonData.filter(item => item.make.toLowerCase() === make.toLowerCase());
    //const models = filteredData.map(item => item.model);
    //return models

    let models = [];
    for (let item of this.vehicleJsonData) {
      if (item.make === make) {
        if (!models.includes(item.model)) {
          models.push(item.model);
        }
      }
    }
    return models;
  }

  searchYearsByMakeModel(make, model) {
    //const filteredData = this.vehicleJsonData.filter(item => item.make.toLowerCase() === make.toLowerCase());
    //const models = filteredData.map(item => item.model);
    //return models

    let years = [];
    for (let item of this.vehicleJsonData) {
      if (item.make === make && item.model === model) {
        if (!years.includes(item.year)) {
          years.push(item.year);
        }
      }
    }
    return years;
  }

  searchProductsByMakeModelYear(make, model, year) {

    const vehicleObjects = VehicleData.searchVehicle({
      make: make,
      model: model,
      year: year,
    })

    return vehicleObjects;
  }

  customSelectDropdown(selectElement) {
    // Hide the original select element
    selectElement.style.display = "none";

    // Create a custom container element for the dropdown
    const container = document.createElement("div");
    container.classList.add("custom-select");

    // Create a custom display element for the selected option
    const display = document.createElement("div");
    display.classList.add("custom-select-display");

    // Add the initial selected option to the display element
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    display.innerText = selectedOption.innerText;

    // Create a custom options list element for the dropdown
    const optionsList = document.createElement("ul");
    optionsList.classList.add("custom-select-options");

    // Add each option from the original select element to the custom options list
    for (let i = 0; i < selectElement.options.length; i++) {
      const option = selectElement.options[i];
      const li = document.createElement("li");
      li.innerText = option.innerText;
      li.addEventListener("click", () => {
        // Update the display element with the selected option
        display.innerText = option.innerText;

        // Update the original select element with the selected option
        selectElement.value = option.value;
      });
      optionsList.appendChild(li);
    }

    // Add the display and options list elements to the container
    container.appendChild(display);
    container.appendChild(optionsList);

    // Add the container to the DOM
    selectElement.parentNode.insertBefore(container, selectElement.nextSibling);
  }
};

if (!window.customElements.get("vehicle-picker")) {
  window.customElements.define("vehicle-picker", VehiclePicker);
}

export { VehiclePicker };
